<div class="title-row field-group mt-2" fxLayout="row" fxLayoutAlign="space-between center">
  <main class="title-simple-steps">
    <h1>
      {{ titleKey | translate }}
    </h1>
    <p *ngIf="descriptionKey" class="step-description my-2">{{ descriptionKey | translate }}</p>
  </main>
  <button
    *ngIf="showSkip"
    type="button"
    class="skip-btn"
    [class.skip-btn-disabled]="isFromPrevious"
    [matTooltip]="isFromPrevious ? ('Done_Skip_Before' | translate) : null"
    (click)="!isFromPrevious && onSkip()"
  >
    {{ "Skip" | translate }}
  </button>
</div>
<form
  class="sign-up-form"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  [formGroup]="form"
  (ngSubmit)="submit()"
>

  <div class="field-group">
    <app-upload-file
      [isRequired]="false"
      variant="business-logo"
      (getFile)="onGetFile($event)"
      (fileCleared)="onClearLogo()"
      (fileSizeError)="onFileSizeError()"
      [imageUrl]="imgSrc"
    ></app-upload-file>
  </div>

  <div class="field-group">
    <mat-label class="label">
      {{ "Role" | translate }}
      <span class="text-[#6059a2]">*</span>
    </mat-label>
    <mat-form-field appearance="outline">
      <mat-select
        disableRipple
        formControlName="PositionId"
        [placeholder]="'Role' | translate"
      >
        <mat-option
          *ngFor="let position of positions"
          [value]="position.PositionId"
        >
          {{ dir == 'rtl' ? position.NameAr : position.NameEn }}
        </mat-option>
      </mat-select>
      <mat-error>
        <app-error-form
          [name]="'Role' | translate"
          [control]="form.controls['PositionId']"
        ></app-error-form>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="field-group">
    <mat-label class="label">
      {{ "Working_Phone_Number" | translate }}
      <span class="text-[#6059a2]">*</span>
    </mat-label>
    <div class="phone-row" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
      <mat-form-field class="phone-country-code" appearance="outline">
        <mat-select
          formControlName="CountryId"
          [placeholder]="'Select_Country' | translate"
          (selectionChange)="onCountryChange($event.value)"
        >
          <mat-select-trigger>
            <ng-container *ngIf="getSelectedCountry()">
              <div class="d-flex align-items-center">
                <img
                  [src]="getSelectedCountry()?.FlagPath"
                  width="24px"
                  alt=""
                  style="border: 1px solid #ddd"
                />
                <span class="mx-1 text-xl">{{ getSelectedCountry()?.CallingCode }}</span>
              </div>
            </ng-container>
          </mat-select-trigger>
          <mat-option *ngFor="let country of countries" [value]="country.Id">
            <div class="d-flex align-items-center">
              <img
                [src]="country.FlagPath"
                width="24px"
                alt=""
                style="border: 1px solid #ddd"
              />
              <span class="mx-1 text-xl">{{ country.CallingCode }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="phone-number-input" appearance="outline">
        <input
          [dir]="dir"
          type="tel"
          matInput
          formControlName="BusinessPhoneNumber"
          [placeholder]="'ENTER_PHONE_NUMBER' | translate"
          [maxLength]="12"
          appNumberOnly
        />
        <mat-error>
          <app-error-form
            [name]="'Working_Phone_Number' | translate"
            [control]="form.controls['BusinessPhoneNumber']"
            [maxLength]="12"
            [minLength]="4"
          ></app-error-form>
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div fxLayout="row wrap" fxLayoutAlign="space-between start" class="field-group stepper-fields-row">
    <div
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      fxFlex.gt-sm="47"
      fxFlex.lt-md="100"
      class="stepper-field-col"
    >
      <mat-label class="label">
        {{ "NumberOfEmployees" | translate }}
        <span class="text-[#6059a2]">*</span>
      </mat-label>
      <div class="stepper-input">
        <button type="button" class="stepper-btn minus-btn" (click)="decrement('NumberOfEmployees')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-dash-lg" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"/>
          </svg>
        </button>
        <input
          type="number"
          class="stepper-value text-[#000]"
          formControlName="NumberOfEmployees"
          min="1"
          appNumberOnly
        />
        <button type="button" class="stepper-btn plus-btn" (click)="increment('NumberOfEmployees')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
          </svg>
        </button>
      </div>
      <div
        class="stepper-error"
        *ngIf="form.controls['NumberOfEmployees']?.touched || form.controls['NumberOfEmployees']?.dirty"
      >
        <app-error-form
          [name]="'NumberOfEmployees' | translate"
          [control]="form.controls['NumberOfEmployees']"
          [min]="1"
        ></app-error-form>
      </div>
    </div>
    <div
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      fxFlex.gt-sm="47"
      fxFlex.lt-md="100"
      class="stepper-field-col-number-of-branches stepper-field-col"
      >
      <mat-label class="label">
        {{ "NumberOfBranches" | translate }}
        <span class="text-[#6059a2]">*</span>
      </mat-label>
      <div class="stepper-input">
        <button type="button" class="stepper-btn minus-btn" (click)="decrement('NumberOfBranches')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-dash-lg" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"/>
          </svg>
        </button>
        <input
          type="number"
          class="stepper-value text-[#000]"
          formControlName="NumberOfBranches"
          min="1"
          appNumberOnly
        />
        <button type="button" class="stepper-btn plus-btn" (click)="increment('NumberOfBranches')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
          </svg>
        </button>
      </div>
      <div
        class="stepper-error"
        *ngIf="form.controls['NumberOfBranches']?.touched || form.controls['NumberOfBranches']?.dirty"
      >
        <app-error-form
          [name]="'NumberOfBranches' | translate"
          [control]="form.controls['NumberOfBranches']"
          [min]="1"
        ></app-error-form>
      </div>
    </div>
  </div>

  <div
    class="actions-buttons"
    *ngIf="showActions"
    fxLayout="row"
    fxLayoutAlign="stretch center"
  >
    <button
      *ngIf="previousLabelKey"
      type="button"
      class="action-btn prev-btn"
      fxFlex="1 1 0"
      (click)="onPrevious()"
    >
      {{ previousLabelKey | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      class="action-btn submit-btn"
      fxFlex="1 1 0"
      type="submit"
      [disabled]="!canSubmit || loading"
    >
      {{ submitLabelKey | translate }}
      <span class="btn-spinner-icon" *ngIf="loading"></span>
    </button>
  </div>
</form>
